import { ProcedureType, SampleType } from "@/services/backend/types";
import CountingTable from "@/shared/components/domain/counting/counting-table";
import { useParams } from "react-router";
import { useShowCountingQuery } from "@/services/backend/countings/service";

export function FirstCountingIndexRoute() {
  const { countingId } = useParams();
  const { data: counting } = useShowCountingQuery({ id: countingId! });
  const immutable = !!counting?.counting.immutable;

  return (
    <div className="flex w-full flex-col">
      <div className="flex w-full flex-col space-y-4">
        <CountingTable
          label="Oberflächenkeimprobe - 1N-RLT"
          ownerId={countingId as string}
          ownerType="counting.Counting"
          procedureType={ProcedureType.RLT1N}
          sampleType={SampleType.SurfaceMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Oberflächenkeimprobe - 2N-RLT"
          ownerId={countingId as string}
          ownerType="counting.Counting"
          procedureType={ProcedureType.RLT2N}
          sampleType={SampleType.SurfaceMicrobial}
          visibilityState={{ "measurement-2": false }}
          immutable={immutable}
        />

        <CountingTable
          label="Luftkeimprobe - 1N-RLT"
          ownerId={countingId as string}
          ownerType="counting.Counting"
          procedureType={ProcedureType.RLT1N}
          sampleType={SampleType.AirMicrobial}
          immutable={immutable}
        />

        <CountingTable
          label="Luftkeimprobe - 2N-RLT"
          ownerId={countingId as string}
          ownerType="counting.Counting"
          procedureType={ProcedureType.RLT2N}
          sampleType={SampleType.AirMicrobial}
          visibilityState={{ "measurement-2": false }}
          immutable={immutable}
        />
      </div>
    </div>
  );
}
